import { Badge } from 'reactstrap'
import { components } from 'react-select'
import { UserCheck, User, Users, Circle, TrendingDown, TrendingUp, Award } from 'react-feather'
import ReactCountryFlag from 'react-country-flag'
import moment from 'moment'
import Avatar from 'src/core/components/avatar'
import Metamask from 'src/assets/images/icons/metamask.svg'
import Solana from 'src/assets/images/icons/solana.svg'
import Nowpayments from 'src/assets/images/icons/nowpayments.png'
import Admin from 'src/assets/images/icons/admin.png'
import Phantom from 'src/assets/images/icons/phantom.png'
import logoText from 'src/assets/images/logo/logo_text.png'
import logoIcon from 'src/assets/images/logo/logo_icon.png'

const Config = {
	Socket: null,
	apiUrl: `${process.env.REACT_APP_API_URL}/`,
	socketUrl: `${process.env.REACT_APP_SOCKET_API_URL}/`,

	app: {
		appName: 'BetsCycle',
		appLogoImage: logoText,
		appLogoIcon: logoIcon,
	},

	layout: {
		isRTL: false,
		skin: 'dark',
		routerTransition: 'fadeIn',
		type: 'vertical',
		contentWidth: 'full',
		menu: {
			isHidden: false,
			isCollapsed: false,
		},
		navbar: {
			type: 'floating',
			backgroundColor: 'white',
		},
		footer: {
			type: 'static',
		},
		customizer: false,
		scrollTop: true,
	},

	/**
	 * API Endpoints
	 */
	SignIn: 'auth/login',
	SignOut: 'auth/revoke-token',
	Players: 'players',
	OnlinePlayers: 'players/session',
	Roles: 'players/roles',
	LoginHistory: 'history/player-login',
	Referrals: 'players/referral',
	PlayerCommissionLevels: 'players/commission-level',
	PlayerReferralRewardHistory: 'history/player-reward',

	Affiliates: 'affiliates',
	OnlineAffiliates: 'affiliates/session',
	AffiliateLoginHistory: 'history/affiliate-login',
	RewardHistory: 'history/affiliate-reward',

	V2SportsList: 'v2sports/history',

	Casinos: 'casinos',
	CasinosProviders: 'casinos/providers',
	CasinosTypes: 'casinos/types',
	CasinosTagCategories: 'casinos/tag-categories',
	CasinosTags: 'casinos/tags',
	CasinosLists: 'casinos/casino',
	CasinoCategory: 'casinos/categories',
	CasinosHistory: 'history/casino',

	SportsbooksProviders: 'sportsbooks/providers',
	SportsbooksTypes: 'sportsbooks/types',
	SportsbooksLists: 'sportsbooks/sportsbook',
	Sportsbooks: 'sportsbooks',
	SportsbooksHistory: 'history/sportsbook',

	ColorgameHistory: 'colorgames/list',
	ColorgameResult: 'colorgames/result',
	ColorGameCategories: 'colorgames/getCategories',
	AddColorGame: 'colorgames/addColorGame',
	UpdateColorGameCategory: 'colorgames/updateColorGameCategory',
	DeleteColorGameCategory: 'colorgames/deleteColorGameCategory',

	OriginalGamesLists: 'original/game',
	OriginalGamesHistory: 'history/original',

	P2pMarkets: 'p2p/market',
	P2pHistory: 'history/p2p',

	LoyaltyTiers: 'loyalty/tiers',
	LoyaltyPoints: 'loyalty/points',
	LoyaltyTierHistory: 'history/loyalty-tier',
	LoyaltyPointHistory: 'history/loyalty-point',
	LoyaltyRewardHistory: 'history/loyalty-reward',

	PromotionCampaigns: 'promotion/campaign',
	PromotionRewardHistory: 'history/promotion-reward',

	FraudIp: 'fraud/ip',
	FraudFpid: 'fraud/fpid',
	FraudIpBlacklist: 'fraud/ip-blacklist',
	FraudFpidBlacklist: 'fraud/fpid-blacklist',

	SportsBets: 'sports/bets',
	SportsLists: 'sports/lists',
	Sportsv0History: 'casinos/sportsv0',
	SportsResult: 'sports/result',
	SportsMatchs: 'sports/matchs',
	SportsLeagues: 'sports/leagues',
	SportsBettings: 'sports/bettings',
	SportsFixMatchs: 'sports/fixmatchs',
	SportsEndMatchs: 'sports/endmatchs',
	SportsResettle: 'sports/resettle',

	BracketsBets: 'brackets/bets',
	BracketsMatchs: 'brackets/matchs',

	Payments: 'history/payment',
	Balance: 'payment/balance',
	AdminBalance: 'payment/admin/balance',
	Currencies: 'currency',
	UpdateBalance: 'payment/updateBalance',
	BalanceHistory: 'history/balance',

	DashboardReport: 'report/dashboard',
	PlayerReport: 'report/player',

	RewardsUpdate: 'rewards/update',
	RewardsSymbolUpdate: 'rewards/updateSymbol',

	Language: 'setting/language',
	LanguageWords: 'setting/word',

	Files: 'files',
	Settings: 'settings',
	AddPrivacy: 'privacies/add',
	GetPrivacy: 'privacies/get',
	UpdatePrivacy: 'privacies/update',
}

export const sortOptions = [
	{
		label: 'ASC',
		value: 1,
	},
	{
		label: 'DESC',
		value: -1,
	},
]

export const enabledOptions = [
	{ value: 'active', label: 'Active' },
	{ value: 'disabled', label: 'Disabled' },
]

export const statusOptions = [
	{ value: true, label: 'Active' },
	{ value: false, label: 'Inactive' },
]

export const statusObj = {
	true: 'light-success',
	false: 'light-secondary',
}

export const userStatusOptions = [
	{ value: 'activated', label: 'Activated' },
	{ value: 'pending', label: 'Pending' },
	{ value: 'suspended', label: 'Suspended' },
	{ value: 'blocked', label: 'Blocked' },
]

export const balanceObj = {
	'deposit-metamask': {
		title: 'Deposit',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	'withdrawal-metamask': {
		title: 'Withdrawal',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	'withdrawal-metamask-canceled': {
		title: 'Withdrawal Canceled',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	'deposit-nowpayments': {
		title: 'Deposit',
		icon: <img src={Nowpayments} alt='nowpayments' title='nowpayments' width='24px' />,
	},
	'withdrawal-nowpayments': {
		title: 'Withdrawal',
		icon: <img src={Nowpayments} alt='nowpayments' title='nowpayments' width='24px' />,
	},
	'deposit-admin': {
		title: 'Deposit',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	'withdrawal-admin': {
		title: 'Withdrawal',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	'sports-single-bet': {
		title: 'Single Bet',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'sports-single-settled': {
		title: 'Single Settled',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'sports-multi-bet': {
		title: 'Multi Bet',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'sports-multi-settled': {
		title: 'Multi Settled',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'sports-brackets-bet': {
		title: 'Brackets Bet',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'sports-brackets-settled': {
		title: 'Brackets Bet',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'sports-resettle': {
		title: 'Single Resettle',
		icon: <img src={logoIcon} alt='bet' title='bet' width='24px' />,
	},
	'referral-bonus': {
		title: 'Referral Bonus',
		icon: <Award size={24} className='text-danger' />,
	},
}

export const balanceOptions = [
	{
		label: 'Deposit Nowpayments',
		value: 'deposit_nowpayments',
		icon: <img src={Nowpayments} alt='nowpayments' title='nowpayments' width='24px' />,
	},
	{
		label: 'Withdrawal Nowpayments',
		value: 'withdrawal_nowpayments',
		icon: <img src={Nowpayments} alt='nowpayments' title='nowpayments' width='24px' />,
	},
	{
		label: 'Deposit Metamask',
		value: 'deposit_metamask',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	{
		label: 'Withdrawal Metamask',
		value: 'withdrawal_metamask',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	{
		label: 'Deposit Solana',
		value: 'deposit_solana',
		icon: <img src={Solana} alt='solana' title='solana' width='24px' />,
	},
	{
		label: 'Withdrawal Solana',
		value: 'withdrawal_solana',
		icon: <img src={Solana} alt='solana' title='solana' width='24px' />,
	},
	{
		label: 'Deposit Admin',
		value: 'deposit_admin',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Withdrawal Admin',
		value: 'withdrawal_admin',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Cancel Withdrawal',
		value: 'cancel_withdrawal',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Casino Bet',
		value: 'casino_bet',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Casino Commit',
		value: 'casino_commit',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Casino Win',
		value: 'casino_win',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Casino Refund',
		value: 'casino_refund',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Casino Rollback',
		value: 'casino_rollback',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Sportsbook Bet',
		value: 'sportsbook_bet',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Sportsbook Win',
		value: 'sportsbook_win',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Sportsbook Settle',
		value: 'sportsbook_settle',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'P2P Join',
		value: 'p2p_join',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'P2P Resolve',
		value: 'p2p_resolve',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Game Bet',
		value: 'game_bet',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Game Win',
		value: 'game_win',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'CPA',
		value: 'cpa',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
	{
		label: 'Commission',
		value: 'commission',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
]

export const paymentOptions = [
	{ value: 'crypto', label: 'Crypto' },
	{ value: 'fiat', label: 'Fiat' },
]

export const paymentStatusObj = {
	withdrawal: 'light-danger',
	deposit: 'light-success',
}

export const paymentMethod = {
	nowpayments: {
		title: 'nowpayments',
		icon: <img src={Nowpayments} alt='nowpayments' title='nowpayments' width='24px' />,
	},
	metamask: {
		title: 'metamask',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	solana: {
		title: 'solana',
		icon: <img src={Solana} alt='solana' title='solana' width='24px' />,
	},
	admin: {
		title: 'admin',
		icon: <img src={Admin} alt='metamask' title='metamask' width='24px' />,
	},
}

export const paymentMethodOptions = [
	{
		value: 'nowpayments',
		label: 'Nowpayments',
		icon: <img src={Nowpayments} alt='nowpayments' title='nowpayments' width='24px' />,
	},
	{
		value: 'metamask',
		label: 'Metamask',
		icon: <img src={Metamask} alt='metamask' title='metamask' width='24px' />,
	},
	{
		value: 'phantom',
		label: 'Phantom',
		icon: <img src={Phantom} alt='phantom' title='phantom' width='24px' />,
	},
	{
		value: 'admin',
		label: 'Admin',
		icon: <img src={Admin} alt='admin' title='admin' width='24px' />,
	},
]

export const paymentTypeOptions = [
	{
		value: 'deposit',
		label: 'Deposit',
		icon: TrendingUp,
	},
	{
		value: 'withdrawal',
		label: 'Withdrawal',
		icon: TrendingDown,
	},
]

export const timeStatusOptions = [
	{ value: 0, label: 'Not Started' },
	{ value: 1, label: 'InPlay' },
	{ value: 2, label: 'To Be Fixed' },
	{ value: 3, label: 'Ended' },
	{ value: 4, label: 'Postponed' },
	{ value: 5, label: 'Cancelled' },
	{ value: 6, label: 'Walkover' },
	{ value: 7, label: 'Interrupted' },
	{ value: 8, label: 'Abandoned' },
	{ value: 9, label: 'Retired' },
	{ value: 99, label: 'Removed' },
	{ value: 100, label: 'Settled' },
	{ value: 101, label: 'Canceled' },
]

export const timeStatus = {
	0: 'Not Started',
	1: 'In Play',
	2: 'To Be Fixed',
	3: 'Ended',
	4: 'Postponed',
	5: 'Cancelled',
	6: 'Walkover',
	7: 'Interrupted',
	8: 'Abandoned',
	9: 'Retired',
	10: 'Suspended',
	99: 'Removed',
	100: 'Settled',
	101: 'Canceled',
}

export const bettingTypeOptions = [
	{
		value: 'single',
		label: 'Single',
		icon: Circle,
	},
	{
		value: 'multi',
		label: 'Multi',
		icon: Circle,
	},
]

export const bettingStatusOptions = [
	{
		value: 'BET',
		label: 'Active',
		icon: Circle,
	},
	{
		value: 'WIN',
		label: 'Win',
		icon: Circle,
	},
	{
		value: 'LOST',
		label: 'Lost',
		icon: Circle,
	},
	{
		value: 'HALF_WIN',
		label: 'Half Win',
		icon: Circle,
	},
	{
		value: 'HALF_LOST',
		label: 'Half Lost',
		icon: Circle,
	},
	{
		value: 'REFUND',
		label: 'Refund',
		icon: Circle,
	},
	{
		value: 'CANCEL',
		label: 'Cancel',
		icon: Circle,
	},
	{
		value: 'SETTLED',
		label: 'Settled',
		icon: Circle,
	},
]

export const resultType = [
	{ value: 'BET', color: 'light-primay' },
	{ value: 'WIN', color: 'light-success' },
	{ value: 'HALF_WIN', color: 'light-success' },
	{ value: 'LOST', color: 'light-danger' },
	{ value: 'HALF_LOST', color: 'light-danger' },
	{ value: 'REFUND', color: 'light-secondary' },
	{ value: 'CANCEL', color: 'light-secondary' },
]

export const casinoTypeOptions = [
	{
		label: 'Balance',
		value: 'balance',
	},
	{
		label: 'Bet',
		value: 'bet',
	},
	{
		label: 'Commit',
		value: 'commit',
	},
	{
		label: 'Win',
		value: 'win',
	},
	{
		label: 'Refund',
		value: 'refund',
	},
	{
		label: 'Rollback',
		value: 'rollback',
	},
	{
		label: 'Settle',
		value: 'settle',
	},
]

export const sportsbookStatusOptions = [
	{
		value: 'open',
		label: 'Open',
	},
	{
		value: 'settled',
		label: 'Settled',
	},

	{
		value: 'win',
		label: 'Win',
	},
	{
		value: 'lost',
		label: 'Lost',
	},
	{
		value: 'refund',
		label: 'Refund',
	},
	{
		value: 'discard',
		label: 'Discard',
	},
	{
		value: 'cashout',
		label: 'Cashout',
	},
	{
		value: 'half-win',
		label: 'Half Win',
	},
	{
		value: 'half-lose',
		label: 'Half Lose',
	},
	{
		value: 'default',
		label: 'Default',
	},
	{
		value: 'reject',
		label: 'Reject',
	},
]

export const colorOptions = [
	{
		label: '#00CFE8',
		value: '#00CFE8',
	},
	{
		label: '#7367F0',
		value: '#7367F0',
	},
	{
		label: '#EA5455',
		value: '#EA5455',
	},
	{
		label: '#ffe81a',
		value: '#ffe81a',
	},
	{
		label: '#27AE60',
		value: '#27AE60',
	},
	{
		label: '#FF9F43',
		value: '#FF9F43',
	},
	{
		label: '#E83E8C',
		value: '#E83E8C',
	},
	{
		label: '#3498DB',
		value: '#3498DB',
	},
	{
		label: '#9C27B0',
		value: '#9C27B0',
	},
	{
		label: '#464646',
		value: '#464646',
	},
	{
		label: '#dee2f4',
		value: '#dee2f4',
	},
]

export const colorStatusOptions = [
	{
		value: 'LOST',
		label: 'Lost',
		icon: Circle,
	},
	{
		value: 'PENDING',
		label: 'Bet',
		icon: Circle,
	},
	{
		value: 'WIN',
		label: 'Win',
		icon: Circle,
	},
]

export const gameTypeOptions = [
	{
		value: 1,
		label: '1min',
	},
	{
		value: 2,
		label: '3mins',
	},
	{
		value: 3,
		label: '5mins',
	},
	{
		value: 4,
		label: '10mins',
	},
]

export const gameStatusOptions = [
	{
		value: 'pending',
		label: 'Pending',
		icon: Circle,
	},
	{
		value: 'finished',
		label: 'Finished',
		icon: Circle,
	},
]

export const originalGameTypeOptions = [
	{
		value: 'coinflip',
		label: 'Coinflip',
	},
	{
		value: 'crashrocket',
		label: 'Crashrocket',
	},
	{
		value: 'diamonds',
		label: 'Diamonds',
	},
	{
		value: 'dice',
		label: 'Dice',
	},
	{
		value: 'flowerpocket',
		label: 'Flowerpocket',
	},
	{
		value: 'keno',
		label: 'Keno',
	},
	{
		value: 'mine',
		label: 'Mine',
	},

	{
		value: 'plinko',
		label: 'Plinko',
	},
	{
		value: 'slide',
		label: 'Slide',
	},
	{
		value: 'wheel',
		label: 'Wheel',
	},
]

export const originalGameActionTypeOptions = [
	{
		value: 'bet',
		label: 'Bet',
	},
	{
		value: 'draw',
		label: 'Draw',
	},
	{
		value: 'win',
		label: 'Win',
	},
	{
		value: 'lost',
		label: 'Lost',
	},
]

export const p2pCategoryOptions = [
	{
		label: 'Sports',
		value: 'Sports',
	},
	{
		label: 'Crypto',
		value: 'Crypto',
	},
	{
		label: 'News',
		value: 'News',
	},
	{
		label: 'Business',
		value: 'Business',
	},
]

export const p2pOptions = [
	{ value: 'active', label: 'Active' },
	{ value: 'Settled', label: 'Settled' },
	{ value: 'Closed', label: 'Closed' },
]

export const p2pMarketStatus = [
	{ value: 'active', label: 'Active' },
	{ value: 'cancelled', label: 'Cancelled' },
	{ value: 'finished', label: 'Finished' },
	{ value: 'resolved', label: 'Resolved' },
]

export const p2pOptionStatus = [
	{ value: 'unknown', label: 'Unknown' },
	{ value: 'yes', label: 'Yes' },
	{ value: 'no', label: 'No' },
]

export const loyaltySourceTypeOptions = [
	{ value: 'deposit', label: 'Deposit' },
	{ value: 'casino_bet', label: 'Casino Bet' },
	{ value: 'sportsbook_bet', label: 'Sportsbook Bet' },
	{ value: 'game_bet', label: 'Game Bet' },
	{ value: 'referral_commission', label: 'Referral Commission' },
	{ value: 'admin', label: 'Admin' },
]

export const loyaltyRewardTypeOptions = [
	{ value: 'daily_bonus', label: 'Daily Bonus' },
	{ value: 'weekly_bonus', label: 'Weekly Bonus' },
	{ value: 'monthly_bonus', label: 'Monthly Bonus' },
	{ value: 'daily_rakeback', label: 'Daily Rakeback' },
	{ value: 'weekly_cashback', label: 'Weekly Cashback' },
	{ value: 'monthly_cashback', label: 'Monthly Cashback' },
	{ value: 'daily_freespin', label: 'Daily Freespin' },
	{ value: 'weekly_freespin', label: 'Weekly Freespin' },
	{ value: 'monthly_freespin', label: 'Monthly Freespin' },
	{ value: 'level_up_bonus', label: 'Level Up Bonus' },
	{ value: 'level_up_freespin', label: 'Level Up Freespin' },
]

export const loyaltyRewardStatusOptions = [
	{ value: 'pending', label: 'Pending' },
	{ value: 'claimed', label: 'Claimed' },
	{ value: 'rejected', label: 'Rejected' },
]

export const playerReferralSourceTypeOptions = [
	{ value: 'register', label: 'Register' },
	{ value: 'deposit', label: 'Deposit' },
	{ value: 'bet', label: 'Bet' },
]

export const playerReferralRewardTypeOptions = [
	{ value: 'cpa', label: 'CPA' },
	{ value: 'commission', label: 'Commission' },
]

export const playerReferralRewardStatusOptions = [
	{ value: 'pending', label: 'Pending' },
	{ value: 'claimed', label: 'Claimed' },
	{ value: 'rejected', label: 'Rejected' },
]

export const affiliateSourceTypeOptions = [
	{ value: 'register', label: 'Register' },
	{ value: 'deposit', label: 'Deposit' },
	{ value: 'bet', label: 'Bet' },
]

export const affiliateRewardTypeOptions = [
	{ value: 'cpa', label: 'CPA' },
	{ value: 'commission', label: 'Commission' },
]

export const affiliateRewardStatusOptions = [
	{ value: 'pending', label: 'Pending' },
	{ value: 'claimed', label: 'Claimed' },
	{ value: 'rejected', label: 'Rejected' },
]

export const campaignTypeOptions = [
	{ value: 'no_deposit_bonus', label: 'No Deposit Bonus' },
	{ value: 'deposit_bonus', label: 'Deposit Bonus' },
	{ value: 'deposit_challenge', label: 'Deposit Challenge' },
	{ value: 'wager_challenge', label: 'Wager Challenge' },
	{ value: 'reload', label: 'Reload' },
	{ value: 'bonus', label: 'Bonus' },
	{ value: 'cashback', label: 'Cashback' },
	{ value: 'freespin', label: 'Freespin' },
	{ value: 'freevoucher', label: 'Freevoucher' },
	{ value: 'birthday', label: 'Birthday' },
	{ value: 'anniversary', label: 'Anniversary' },
	{ value: 'retention', label: 'Retention' },
	{ value: 'achievement', label: 'Achievement' },
	{ value: 'streak', label: 'Streak' },
	{ value: 'loyalty', label: 'Loyalty' },
	{ value: 'referral', label: 'Referral' },
	{ value: 'custom', label: 'Custom' },
]

export const campaignRewardTypeOptions = [
	{ value: 'bonus', label: 'Bonus' },
	{ value: 'freespin', label: 'Freespin' },
	{ value: 'freevoucher', label: 'Freevoucher' },
	{ value: 'cashback', label: 'Cashback' },
	{ value: 'loyalty_points', label: 'Loyalty Points' },
]

export const campaignRewardStatusOptions = [
	{ value: 'pending', label: 'Pending' },
	{ value: 'claimed', label: 'Claimed' },
	{ value: 'rejected', label: 'Rejected' },
]

export const campaignClaimTypeOptions = [
	{ value: 'auto', label: 'Auto' },
	{ value: 'manual', label: 'Manual' },
	{ value: 'promo_code', label: 'Promo Code' },
]

export const campaignStatusOptions = [
	{ value: 'active', label: 'Active' },
	{ value: 'paused', label: 'Paused' },
	{ value: 'canceled', label: 'Canceled' },
	{ value: 'forfeited', label: 'Forfeited' },
]

export const campaignConditionTypeOptions = [
	{ value: 'registration', label: 'Registration' },
	{ value: 'first_time_deposit', label: 'First Time Deposit' },
	{ value: 'total_deposit_amount', label: 'Total Deposit Amount' },
	{ value: 'deposit_count', label: 'Deposit Count' },
	{ value: 'total_wager_amount', label: 'Total Wager Amount' },
	{ value: 'wager_count', label: 'Wager Count' },
	{ value: 'total_loss_amount', label: 'Total Loss Amount' },
	{ value: 'loyalty_tier', label: 'Loyalty Tier' },
	{ value: 'loyalty_points', label: 'Loyalty Points' },
	{ value: 'birthday', label: 'Birthday' },
	{ value: 'country', label: 'Country' },
	{ value: 'referral_count', label: 'Referral Count' },
	{ value: 'affiliate', label: 'Affiliate' },
	{ value: 'registration_days', label: 'Registration Days' },
	{ value: 'last_login_days', label: 'Last Login Days' },
]

export const campaignOperatorTypeOptions = [
	{ value: '=', label: 'Equal (=)' },
	{ value: '!=', label: 'Not Equal (!=)' },
	{ value: '>', label: 'Greater Than (>)' },
	{ value: '<', label: 'Less Than (<)' },
	{ value: '>=', label: 'Greater Than Or Equal (>=)' },
	{ value: '<=', label: 'Less Than Or Equal (<=)' },
	{ value: 'IN', label: 'In (IN)' },
	{ value: 'NOT IN', label: 'Not In (NOT IN)' },
]

export const fraudEntityStatusOptions = [
	{ value: 'allowed', label: 'Allowed' },
	{ value: 'blocked', label: 'Blocked' },
]

export const fraudEntityStatusObj = {
	allowed: 'light-success',
	blocked: 'light-danger',
}

export const blockedStatusOptions = [
	{ value: true, label: 'Blocked' },
	{ value: false, label: 'Allowed' },
]

export const capitalize = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1)
}

export const getPaymentStatus = (params) => {
	if (params.type === 'withdrawal') {
		if (params.status === 'pending') {
			return 'light-secondary'
		} else if (params.status === 'confirmed') {
			return 'light-success'
		} else if (params.status === 'canceled') {
			return 'light-danger'
		}
	} else if (params.type === 'deposit') {
		if (params.status === 'waiting') {
			return 'light-secondary'
		} else if (params.status === 'confirmed' || params.status === 'finished' || params.status === 'partially_paid') {
			return 'light-success'
		} else if (params.status === 'canceled') {
			return 'light-danger'
		}
	}
}

export const renderRole = (title) => {
	const roleObj = {
		player: {
			class: 'text-primary',
			icon: User,
		},
		admin: {
			class: 'text-danger',
			icon: UserCheck,
		},
		affiliate: {
			class: 'text-warning',
			icon: Users,
		},
		undefined: {
			class: 'text-warning',
			icon: User,
		},
	}
	const Icon = roleObj[title] ? roleObj[title].icon : Edit
	return (
		<span className='text-truncate text-capitalize align-middle'>
			<Icon size={18} className={`${roleObj[title] ? roleObj[title].class : ''} mr-50`} />
			{title}
		</span>
	)
}

const today = new Date()
const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
const lastDay = new Date(moment(firstDay).add(1, 'month'))
export const defaultDate = [firstDay, lastDay]

const renderAvatar = (user, type = 'player') => {
	const stateNum = user.username.length % 6,
		states = ['light-success', 'light-danger', 'light-warning', 'light-info', 'light-primary', 'light-secondary'],
		color = states[stateNum]
	if (type === 'player') {
		if (user?.avatar_url) {
			return (
				<a href={`/player-report/${user.id}`} target='_blank'>
					<Avatar className='mr-1' img={Config.apiUrl + user.avatar_url} width='32' height='32' />
				</a>
			)
		} else {
			return (
				<a href={`/player-report/${user.id}`} target='_blank'>
					<Avatar color={color || 'primary'} className='mr-1' content={user.username} initials />
				</a>
			)
		}
	} else if (type === 'affiliate') {
		if (user?.avatar_url) {
			return (
				<a href={`/affiliate-report/${user.id}`} target='_blank'>
					<Avatar className='mr-1' img={Config.apiUrl + user.avatar_url} width='32' height='32' />
				</a>
			)
		} else {
			return (
				<a href={`/affiliate-report/${user.id}`} target='_blank'>
					<Avatar color={color || 'primary'} className='mr-1' content={user.username} initials />
				</a>
			)
		}
	}
}

export const UserAvatar = ({ user, type = 'player' }) => {
	if (user) {
		return (
			<div className='d-flex justify-content-left align-items-center'>
				{renderAvatar(user, type)}
				<div className='d-flex flex-column'>
					<div className='user-name text-truncate mb-0 w-150p'>
						<small className='text-truncate text-muted mb-0 w-150p'>@</small>
						<span className='font-weight-bold'>{user.username}</span>
					</div>
					{user?.crypto_account !== '' && (
						<div className='user-name text-truncate mb-0 w-150p'>
							<small className='text-truncate text-muted mb-0 w-150p'>@</small>
							<span className='font-weight-bold'>{user?.crypto_account}</span>
						</div>
					)}
				</div>
			</div>
		)
	} else {
		return <div />
	}
}

const renderAvatarForOption = (data) => {
	const stateNum = data.label.length % 6,
		states = ['light-success', 'light-danger', 'light-warning', 'light-info', 'light-primary', 'light-secondary'],
		color = states[stateNum]

	if (data.avatar_url) {
		return <Avatar className='mr-1' img={Config.apiUrl + data.avatar_url} width='32' height='32' />
	} else {
		return <Avatar color={color || 'primary'} className='mr-1' content={data.label.toUpperCase()} initials />
	}
}

export const UserAvatarForOption = ({ data, ...props }) => (
	<components.Option {...props}>
		{data?.label && (
			<div className='d-flex align-items-center'>
				{renderAvatarForOption(data)}
				{data.label.length === 42 ? `${data.label.slice(0, 6)}...${data.label.slice(38, 42)}` : data.label}
			</div>
		)}
	</components.Option>
)

export const CurrencyComponent = ({ data, ...props }) => (
	<components.Option {...props}>
		<div className='d-flex align-items-center'>
			<img src={data.symbol_url} alt={data.label} className='mr-50' width='25px' />
			{data.label}
		</div>
	</components.Option>
)

export const MethodComponent = ({ data, ...props }) => (
	<components.Option {...props}>
		<div className='d-flex align-items-center'>
			<div className='mr-50'>{data.icon}</div>
			{data.label}
		</div>
	</components.Option>
)

export const CountryComponent = ({ data, ...props }) => (
	<components.Option {...props}>
		<div className='d-flex align-items-center'>
			<ReactCountryFlag className='country-flag flag-icon' countryCode={data.value.toLowerCase()} style={{ width: '1.5rem', height: '1.5rem' }} title={data.label} svg />
			<span className='ml-50'>{data.label}</span>
		</div>
	</components.Option>
)

export const SportsComponent = ({ data, ...props }) => (
	<components.Option {...props}>
		<div className='d-flex align-items-center'>
			{data.value === 0 ? (
				<svg width='24' height='24' viewBox='0 0 16 16' fill='none'>
					<path d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z' fill='#232A33' />
					<path
						d='M2.12309 6.0407L7.66168 8.63243C7.8743 8.7322 8.12373 8.7322 8.33634 8.63243L13.8761 6.0407C14.0412 5.9635 14.0412 5.74376 13.8761 5.66655L8.33634 3.07483C8.12373 2.97506 7.8743 2.97506 7.66168 3.07483L2.12309 5.66655C1.95799 5.74376 1.95799 5.9635 2.12309 6.0407Z'
						fill='#FFAB00'
					/>
					<path
						d='M13.877 7.96256L12.4386 7.29028L8.551 9.10877C8.37877 9.18953 8.18872 9.22992 7.99987 9.22992C7.81101 9.22992 7.62097 9.18953 7.44874 9.10877L3.56115 7.29028L2.12395 7.96256C1.95885 8.03977 1.95885 8.25951 2.12395 8.33671L7.66254 10.9284C7.87515 11.0282 8.12458 11.0282 8.3372 10.9284L13.8758 8.33671C14.0409 8.25951 14.0409 8.03977 13.877 7.96256Z'
						fill='#FFAB00'
					/>
					<path
						d='M13.877 10.2586L12.4386 9.5863L8.551 11.4048C8.37877 11.4856 8.18872 11.5259 7.99987 11.5259C7.81101 11.5259 7.62097 11.4856 7.44874 11.4048L3.56115 9.5863L2.12395 10.2586C1.95885 10.3358 1.95885 10.5555 2.12395 10.6327L7.66254 13.2245C7.87515 13.3242 8.12458 13.3242 8.3372 13.2245L13.8758 10.6327C14.0409 10.5555 14.0409 10.3358 13.877 10.2586Z'
						fill='#FFAB00'
					/>
				</svg>
			) : (
				<i className={`sportsicons sportsicon-${data.value}`} style={{ color: data.icon.color, fontSize: '24px' }} />
			)}
			<span className='ml-50'>{data.label}</span>
		</div>
	</components.Option>
)

export const ProvidersComponent = ({ data, ...props }) => (
	<components.Option {...props}>
		<div className='d-flex align-items-center'>
			<span className='ml-50'>{data.label}</span>
		</div>
	</components.Option>
)

export const renderBettingStatus = (row) => {
	const statusObj = {
		BET: {
			color: 'light-info',
			text: 'ACTIVE',
		},
		WIN: {
			color: 'light-success',
			text: 'WON',
		},
		HALF_WIN: {
			color: 'light-success',
			text: 'HALF WON',
		},
		LOST: {
			color: 'light-danger',
			text: 'LOST',
		},
		HALF_LOST: {
			color: 'light-danger',
			text: 'HALF LOST',
		},
		CANCEL: {
			color: 'light-secondary',
			text: 'CANCEL',
		},
		SETTLED: {
			color: 'light-secondary',
			text: 'SETTLED',
		},
		REFUND: {
			color: 'light-secondary',
			text: 'REFUND',
		},
		DRAW: {
			color: 'light-warning',
			text: 'DRAW',
		},
		undefined: {
			color: 'light-secondary',
			text: 'CANCEL',
		},
	}
	return <Badge color={statusObj[row.status]?.color}>{statusObj[row.status]?.text}</Badge>
}

export const renderCasinoStatus = (row) => {
	const statusObj = {
		BET: {
			color: 'light-info',
			text: 'BET',
		},
		WIN: {
			color: 'light-success',
			text: 'WON',
		},
	}
	return <Badge color={statusObj[row.TYPE]?.color}>{statusObj[row.TYPE]?.text}</Badge>
}

export const renderColorGameStatus = (row) => {
	const statusObj = {
		PENDING: {
			color: 'light-info',
			text: 'BET',
		},
		BET: {
			color: 'light-info',
			text: 'BET',
		},
		WIN: {
			color: 'light-success',
			text: 'WON',
		},
		LOST: {
			color: 'light-danger',
			text: 'LOST',
		},
	}
	return <Badge color={statusObj[row.status]?.color}>{statusObj[row.status]?.text}</Badge>
}

export const renderGameStatus = (row) => {
	const statusObj = {
		Bet: {
			color: 'light-info',
			text: 'BET',
		},
		Win: {
			color: 'light-success',
			text: 'WON',
		},
		Lost: {
			color: 'light-danger',
			text: 'LOST',
		},
		RollBack: {
			color: 'light-secondary',
			text: 'ROLLBACK',
		},
		DebitDecrease: {
			color: 'light-danger',
			text: 'LOST',
		},
		DebitIncrease: {
			color: 'light-success',
			text: 'WON',
		},
	}
	return <Badge color={statusObj[row.Status]?.color}>{statusObj[row.Status]?.text}</Badge>
}

export const renderBettingType = (row) => {
	const statusObj = {
		single: {
			color: 'light-primary',
			text: 'SINGLE',
		},
		multi: {
			color: 'light-warning',
			text: 'MULTI',
		},
		undefined: {
			color: 'light-primary',
			text: 'SINGLE',
		},
	}
	return <Badge color={statusObj[row.type]?.color}>{statusObj[row.type]?.text}</Badge>
}

export const renderP2pStatus = (row) => {
	const statusObj = {
		BET: {
			color: 'light-info',
			text: 'BET',
		},
		LOST: {
			color: 'light-danger',
			text: 'LOST',
		},
		WIN: {
			color: 'light-success',
			text: 'WIN',
		},
		REFUND: {
			color: 'light-warning',
			text: 'REFUND',
		},
	}
	return <Badge color={statusObj[row.status]?.color}>{statusObj[row.status]?.text}</Badge>
}

export const renderP2pType = (row) => {
	const typeObj = {
		Yes: {
			color: 'light-success',
			text: 'Yes',
		},
		No: {
			color: 'light-danger',
			text: 'No',
		},
	}
	return <Badge color={typeObj[row.type]?.color}>{typeObj[row.type]?.text}</Badge>
}

export const renderMarketStatus = (row) => {
	const statusObj = {
		active: {
			color: 'light-info',
			text: 'Active',
		},
		cancelled: {
			color: 'light-secondary',
			text: 'Cancelled',
		},
		finished: {
			color: 'light-secondary',
			text: 'Finished',
		},
		resolved: {
			color: 'light-success',
			text: 'Resolved',
		},
	}
	return <Badge color={statusObj[row.status]?.color}>{statusObj[row.status]?.text}</Badge>
}

export default Config
